__turbopack_context__.v({
  "className": "geist_caca019b-module__5D2XsG__className",
});
